import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { SharedModule } from '../shared/shared.module';
import { GlobalPopupModule } from '../global-popup';

import { EmailNotificationHeaderAgComponent } from './email-preferences/email-notification-header-ag.component';
import { EmailActionsMenuAgRendererComponent } from './email-preferences/email-actions-menu-ag-renderer.component';
import { EmailAddressFormDialog } from './email-preferences/email-address-form-dialog.component';
import { EmailPreferencesComponent } from './email-preferences/email-preferences.component';
import { UserSettingsComponent } from './user-settings.component';
import { UserStorage } from './user-storage';
import { UserSettingsStorage } from './user-settings-storage';
import { EmailPreferencesStorage } from './email-preferences/email-preferences-storage';
import { UserSettingsTabbedComponent } from './user-settings-tabbed-component';
import { UserGeneralPreferencesComponent } from './user-general-preferences-component';
import { CovanceFilterModule } from '../covance-filter/covance-filter.module';
import { UnitStorage } from './unit-storage';
import { EmailPreferenceLevelSelectComponent } from './email-preferences/levels/email-preference-level-select.component';
import { EmailPreferencesCategoriesStorage } from './email-preferences/email-preferences-categories-storage';
import { UserAudienceRoleGuard } from './user-audience-role-guard';

@NgModule({
    declarations: [
        UserSettingsComponent,
        EmailPreferencesComponent,
        EmailNotificationHeaderAgComponent,
        EmailAddressFormDialog,
        EmailActionsMenuAgRendererComponent,
        UserSettingsTabbedComponent,
        UserGeneralPreferencesComponent,
        EmailPreferenceLevelSelectComponent
    ],
    imports: [
        SharedModule,
        CovanceFilterModule,
        GlobalPopupModule,
        CovanceAgGridModule,
        ReactiveFormsModule
    ],
    exports: [
        UserSettingsComponent
    ],
    entryComponents: [
        EmailNotificationHeaderAgComponent,
        EmailAddressFormDialog,
        EmailActionsMenuAgRendererComponent
    ],
    providers: [
        UserStorage,
        UnitStorage,
        EmailPreferencesStorage,
        UserSettingsStorage,
        EmailPreferencesCategoriesStorage,
        UserAudienceRoleGuard,
    ]
})
export class UserModule { }
